// import Swiper from 'swiper'
export default {
  expandNav (state, newValue) {
    state.isExpandNav = newValue
  },
  // 首页列表
  tsHomeList (state, list) {
    let {data, pcMobile} = list
    data.tsWorld = data.tsWorld ? data.tsWorld : {}
    data.theme = data.theme ? data.theme : {}
    data.video = data.video ? data.video : {}
    if (pcMobile) {
      state.homeMobileList.mobileTVAndWord = []
      state.homeMobileList.series.right = []
      state.homeMobileList.banner = data.banner
      state.homeMobileList.tsWorld = data.tsWorld ? data.tsWorld : {}
      state.homeMobileList.multi = data.multi
      state.homeMobileList.series.left = data.series.left
      if (data.series.rightOne) { state.homeMobileList.series.right.push(data.series.rightOne) }
      if (data.series.rightTwo) { state.homeMobileList.series.right.push(data.series.rightTwo) }
      state.homeMobileList.theme = data.theme
      state.homeMobileList.video = data.video
      state.homeMobileList.tsTv = data.tsTv
      if (data.tsWorld.hasOwnProperty('commonId')) {
        data.tsWorld.flag = 'tw'
        state.homeMobileList.mobileTVAndWord.push(data.tsWorld)
      }

      for (let i in data.tsTv) {
        data.tsTv[i].flag = 'tv'
        state.homeMobileList.mobileTVAndWord.push(data.tsTv[i])
      }
      // tv和tw同时为空时的处理
      if (data.tsWorld && data.tsTv.length === 0) {
        state.homeMobileList.mobileTVAndWord = []
      }
    } else {
      // state.homeList.mobileTVAndWord = []
      state.homeList.series.right = []
      state.homeList.banner = data.banner
      state.homeList.tsWorld = data.tsWorld
      state.homeList.multi = data.multi
      state.homeList.series.left = data.series.left
      if (data.series.rightOne) { state.homeList.series.right.push(data.series.rightOne) }
      if (data.series.rightTwo) { state.homeList.series.right.push(data.series.rightTwo) }
      state.homeList.theme = data.theme
      state.homeList.video = data.video
      state.homeList.tsTv = data.tsTv
      // data.tsWorld.flag = 'tw'
      // state.homeList.mobileTVAndWord.push(data.tsWorld)
      // for (let i in data.tsTv) {
      //   data.tsTv[i].flag = 'tv'
      //   state.homeList.mobileTVAndWord.push(data.tsTv[i])
      // }
    }
  },

  tsTvList (state, list) {
    state.tsTV.banner = list.video
    state.tsTV.info = list.content
  }, // tsTV列表
  tsTvBanner (state, banner) {
    state.tsTV.banner = banner
  }, // 获取tsTV的banner
  tsTVdetail (state, info) {
    state.tsTV.detail = info
  }, // tsTV详情
  tsWorldList (state, list) {
    state.tsWorld.list = list
  }, // tsWorld列表
  tsWorldDetail (state, info) {
    state.tsWorld.info = info
  }, // tsWorld列表
  mainPushDetail (state, info) {
    state.mainPush.info = info
  }, // 主推系列详情
  multStockList (state, list) {
    state.multStockData.list.banner = list.banner
    state.multStockData.list.content = list.content
  }, // 多元碰撞列表
  multStockDetail (state, info) {
    state.multStockData.info = info
  }, // 多元碰撞详情
  themeSeriesList (state, list) {
    state.themeSeries.list.banner = list.banner
    state.themeSeries.list.content = list.content
  }, // 主题系列列表
  themeSeriesDetail (state, info) {
    state.themeSeries.info = info
  }, // 主题系列详情
  columnList (state, list) {
    if (list) {
      state.columnData.list.banner = list.banner
      state.columnData.mobileSeries = list.series
      let tempArr = []
      if (list.series.length > 0) {
        for (let item in list.series) {
          if (list.series[item].type === 1) {
            state.columnData.list.series.left = list.series[item]
          } else {
            tempArr.push(list.series[item])
            // if (state.columnData.list.series.right.length < 2) {
            //   state.columnData.list.series.right.push(list.series[item])
            // }
          }
        }
      }
      state.columnData.list.series.right = tempArr
      if (list.products.length > 0) {
        state.columnData.list.products = list.products
      }
    } else {
      state.columnData.list.banner = ''
      state.columnData.list.series.left = {}
      state.columnData.list.series.right = []
      state.columnData.list.products = []
    }
  },
  // 查询商品列表
  queryProduct (state, list) {
    state.productListData = list
  },
  // 查询栏目条件
  queryColumnCondiction (state, list) {
    state.columnCondition = list
    for (let item in state.queryModel) {
      state.columnCondition[item].condiction = state.queryModel[item]
    }
  },
  // 获取商品详情
  getProductDetail (state, list) {
    state.productDetail.swiperShowData = []
    state.productDetail.swiperAllData = []
    state.productDetail.otherColor = []
    state.productDetail.isClick = ['1']
    state.productDetail.item = list.item
    state.productDetail.skc = list.skc
    state.productDetail.swiperAllData = Object.values(list.skc)
    state.productDetail.swiperShowData = state.productDetail.swiperAllData[0]
    for (let i = 0; i < state.productDetail.swiperAllData.length - 1; i++) {
      state.productDetail.isClick.push('0')
    }
    for (let item of Object.values(list.skc)) {
      state.productDetail.otherColor.push(item[0])
    }
  },
  getProductDetailSwiper (state, index) {
    state.productDetail.swiperShowData = []
    state.productDetail.swiperShowData = state.productDetail.swiperAllData[index]
  },
  getProvince (state, list) {
    // 把map转化为数组
    let array = []
    for (let i in list) {
      array.push({value: i, name: list[i]})
    }
    state.provinceData = array
  }, // 省份
  getShopList (state, list) {
    state.shopList.list = list.dataList
    state.shopList.page.curr = list.currentPage
    state.shopList.page.allPage = list.totalPage
    state.shopList.page.total = list.total
  }, // 店铺
  changeShopID (state, list) {
    state.shopID = list
  }, // 修改店铺ID
  // 附近店铺
  nearShopMutation (state, list) {
    state.shopList.nearShop = list
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/mutations.js